module.exports = __webpack_public_path__ + "img/yellow-square-table-8.b79e1171.png";